import {
  FETCH_REGIONAL_AREA_DATA,
  FETCH_CITIES_DATA,
  FETCH_DISTRICTS_DATA,
  FETCH_SUBURBS_DATA,
  FETCH_BOUNDARIES,
  FETCH_POIS,
  FETCH_MOBILE_APPS_LIST
} from '../constants';

export const fetchRegionalAreaData = () => ({
  type: FETCH_REGIONAL_AREA_DATA,
});

export const fetchCitiesData = () => ({
  type: FETCH_CITIES_DATA,
});

export const fetchDistrictsData = () => ({
  type: FETCH_DISTRICTS_DATA,
});

export const fetchSuburbsData = () => ({
  type: FETCH_SUBURBS_DATA,
});

export const fetchBoundaries = () => ({
  type: FETCH_BOUNDARIES,
});

export const fetchPois = () => ({
  type: FETCH_POIS,
});

export const fetchMobileAppsList = () => ({
  type: FETCH_MOBILE_APPS_LIST,
});

